import type { AdvancedSearchResult } from "@circle-react/components/search/types";

export const isResultPost = (result: AdvancedSearchResult) =>
  result.type === "post" && result.slug && result.space_slug;
export const isResultComment = (result: AdvancedSearchResult) =>
  result.type === "comment" && result.post_slug;
export const isResultSpace = (result: AdvancedSearchResult) =>
  result.type === "space";
export const isResultEvent = (result: AdvancedSearchResult) =>
  result.type === "event";
export const isResultCommunityMember = (result: any) =>
  result.type === "community_member" &&
  result.public_uid &&
  result.accepted_invitation;
